/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Forms_Review_DescriptionInputs */

const id_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bagikan pemikiran Anda tentang ${i?.title}`)
};

const ms_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kongsi pendapat anda tentang ${i?.title}`)
};

const da_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Del dine tanker om ${i?.title}`)
};

const de_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Teilen Sie Ihre Gedanken zu ${i?.title}`)
};

const en_us2_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Share your thoughts about ${i?.title}`)
};

const es_es2_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comparte tu opinión sobre ${i?.title}`)
};

const es_mx2_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comparte tu opinión sobre ${i?.title}`)
};

const fil_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ibahagi ang iyong mga saloobin tungkol sa ${i?.title}`)
};

const fr_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Partagez votre opinion sur ${i?.title}`)
};

const it_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Condividi le tue opinioni su ${i?.title}`)
};

const hu_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oszd meg gondolataidat a(z) ${i?.title} játékról`)
};

const nl_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deel je gedachten over ${i?.title}`)
};

const no_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Del dine tanker om ${i?.title}`)
};

const pl_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podziel się swoimi przemyśleniami na temat ${i?.title}`)
};

const pt_br2_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Share your thoughts about ${i?.title}`)
};

const pt_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Partilhe a sua opinião sobre ${i?.title}`)
};

const ro_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Împărtășește-ți gândurile despre ${i?.title}`)
};

const fi_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jaa ajatuksesi pelistä ${i?.title}`)
};

const sv_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dela dina tankar om ${i?.title}`)
};

const vi_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chia sẻ suy nghĩ của bạn về ${i?.title}`)
};

const tr_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} hakkındaki düşüncelerinizi paylaşın`)
};

const cs_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podělte se o své myšlenky o ${i?.title}`)
};

const bg_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Споделете мнението си за ${i?.title}`)
};

const ru_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Поделитесь своими мыслями о ${i?.title}`)
};

const uk_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Поділіться своїми враженнями про ${i?.title}`)
};

const ar_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`شارك أفكارك حول ${i?.title}`)
};

const hi_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} के बारे में अपने विचार साझा करें`)
};

const th_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`แบ่งปันความคิดเห็นของคุณเกี่ยวกับ ${i?.title}`)
};

const ja_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} についての感想を共有`)
};

const zh_cn2_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Share your thoughts about ${i?.title}`)
};

const zh_hant1_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Share your thoughts about ${i?.title}`)
};

const ko_forms_review_description = /** @type {(inputs: Forms_Review_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Share your thoughts about ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Share your thoughts about {title}" |
*
* @param {Forms_Review_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_description = /** @type {((inputs: Forms_Review_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_description(inputs)
	if (locale === "ms") return ms_forms_review_description(inputs)
	if (locale === "da") return da_forms_review_description(inputs)
	if (locale === "de") return de_forms_review_description(inputs)
	if (locale === "en-US") return en_us2_forms_review_description(inputs)
	if (locale === "es-ES") return es_es2_forms_review_description(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_description(inputs)
	if (locale === "fil") return fil_forms_review_description(inputs)
	if (locale === "fr") return fr_forms_review_description(inputs)
	if (locale === "it") return it_forms_review_description(inputs)
	if (locale === "hu") return hu_forms_review_description(inputs)
	if (locale === "nl") return nl_forms_review_description(inputs)
	if (locale === "no") return no_forms_review_description(inputs)
	if (locale === "pl") return pl_forms_review_description(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_description(inputs)
	if (locale === "pt") return pt_forms_review_description(inputs)
	if (locale === "ro") return ro_forms_review_description(inputs)
	if (locale === "fi") return fi_forms_review_description(inputs)
	if (locale === "sv") return sv_forms_review_description(inputs)
	if (locale === "vi") return vi_forms_review_description(inputs)
	if (locale === "tr") return tr_forms_review_description(inputs)
	if (locale === "cs") return cs_forms_review_description(inputs)
	if (locale === "bg") return bg_forms_review_description(inputs)
	if (locale === "ru") return ru_forms_review_description(inputs)
	if (locale === "uk") return uk_forms_review_description(inputs)
	if (locale === "ar") return ar_forms_review_description(inputs)
	if (locale === "hi") return hi_forms_review_description(inputs)
	if (locale === "th") return th_forms_review_description(inputs)
	if (locale === "ja") return ja_forms_review_description(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_description(inputs)
	return ko_forms_review_description(inputs)
});
export { forms_review_description as "forms.review.description" }